import { render, staticRenderFns } from "./personalLayout.vue?vue&type=template&id=08a6e293"
import script from "./personalLayout.vue?vue&type=script&lang=js"
export * from "./personalLayout.vue?vue&type=script&lang=js"
import style0 from "./personalLayout.vue?vue&type=style&index=0&id=08a6e293&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports